import Dexie, { Table } from 'dexie'
import {
	DexieQuizResults,
	DexieQuestion,
	DexieQuiz,
	DexieBadgeGroup,
	DexieBadge,
	DexieTrigger,
	DexieRecentlyEarnedBadge,
	DexieFavouritedKeys,
	DexieFavouritedItem,
	DexieDownload,
} from './types'

export class IndexedDB extends Dexie {
	quizzes?: Table<DexieQuiz, number>
	quizQuestions!: Table<DexieQuestion, number>
	quizResults!: Table<DexieQuizResults, number>
	recentlyEarnedBadges!: Table<DexieRecentlyEarnedBadge, number>
	favouritedKeys!: Table<DexieFavouritedKeys, string>
	favouritedItems!: Table<DexieFavouritedItem, string>
	badgeGroups!: Table<DexieBadgeGroup, number>
	badges!: Table<DexieBadge, number>
	triggers!: Table<DexieTrigger, number>
	downloads!: Table<DexieDownload, string>

	constructor(name: string) {
		super(name)
		this.version(8).stores({
			quizzes: '++id, version',
			// Questions are fetched by the id/quiz/language triple; the count query uses quiz_id alone.
			quizQuestions: '++id, quiz_id, [id+quiz_id+language]',
			quizResults: '++question_id, quiz_id, correct',
			recentlyEarnedBadges: '++badge_id',
			favouritedKeys: '++key',
			favouritedItems: '++key',
			badgeGroups: '++id, version',
			badges: '++id, group_id',
			// Every read of this table filters on triggerable_id and trigger_type together.
			// Without the compound index Dexie scans one index and filters the rest in memory.
			triggers: '++id, triggerable_id, badge_id, trigger_type, [triggerable_id+trigger_type]',
			// The launch refresh reads every row; the queue reads only the unfinished ones, hence the state index.
			downloads: '++key, state',
		})
	}
}

const db = new IndexedDB('database')

export default db
